var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3984 26.4766L16.5234 24.6016C16.1719 24.25 16.1719 23.625 16.5234 23.2734C16.875 22.9219 17.5 22.9219 17.8516 23.2734L19.0234 24.4453L22.1094 20.8125C22.4219 20.4219 23.0469 20.3828 23.4375 20.7344C23.8281 21.0469 23.8672 21.6719 23.5156 22.0625L19.7656 26.4375C19.6094 26.6328 19.375 26.75 19.1016 26.75H19.0625C18.8281 26.75 18.5938 26.6328 18.3984 26.4766ZM26.25 13C27.6172 13 28.75 14.1328 28.75 15.5V28C28.75 29.3672 27.6172 30.5 26.25 30.5H13.75C12.3828 30.5 11.25 29.3672 11.25 28V15.5C11.25 14.1328 12.3828 13 13.75 13H15.3125V11.4375C15.3125 10.9297 15.7422 10.5 16.25 10.5C16.7578 10.5 17.1875 10.9297 17.1875 11.4375V13H22.8125V11.4375C22.8125 10.9297 23.2422 10.5 23.75 10.5C24.2578 10.5 24.6875 10.9297 24.6875 11.4375V13H26.25ZM26.875 28V18H13.125V28C13.125 28.3516 13.3984 28.625 13.75 28.625H26.25C26.6016 28.625 26.875 28.3516 26.875 28Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/Checkin.851ef0686aca4c0569bad16b32d1e0af.svg";
export { ForwardRef as ReactComponent };